document.addEventListener("DOMContentLoaded", () => {
  const slideshow = document.querySelector(".slideshow");

  if (!slideshow) return;

  const colors = [
    "#FFD84D", // Slide 1 - Yellow
    "#5BA9F8", // Slide 2 - Blue
    "#D6D6D6", // Slide 3 - Grey
    "#111111"  // Slide 4 - Black
  ];

  const updateBackground = () => {
    const active =
      slideshow.querySelector(".is-active") ||
      slideshow.querySelector('[aria-current="true"]');

    if (!active) return;

    const slides = [...slideshow.querySelectorAll(".slideshow__slide")];
    const index = slides.indexOf(active);

    if (index >= 0 && colors[index]) {
      document.body.style.transition = "background-color .5s ease";
      document.body.style.backgroundColor = colors[index];
    }
  };

  updateBackground();

  const observer = new MutationObserver(updateBackground);

  observer.observe(slideshow, {
    subtree: true,
    attributes: true,
    attributeFilter: ["class", "aria-current"]
  });
});